import { createSlice } from '@reduxjs/toolkit'

const filterDataSlice = createSlice({
    name: 'filterData',
    initialState: {
        company: '', // Store company ID as string
        customer: '',
        companiesDict: {}, // Dictionary to store company objects by ID
    },
    reducers: {
        setCompany: (state, { payload }) => {
            // Store only the company ID
            state.company = typeof payload === 'object' ? payload.id?.toString() : payload
        },
        setCustomer: (state, { payload }) => {
            state.customer = payload
        },
        setCompaniesDict: (state, { payload }) => {
            // Payload should be an array of company objects
            state.companiesDict = payload.reduce((dict, company) => {
                dict[company.id?.toString()] = company
                return dict
            }, {})
        },
    },
})

export const { setCompany, setCustomer, setCompaniesDict } = filterDataSlice.actions

// Selector to get company object by ID
export const selectCompanyById = (state, companyId) => {
    return state.filterData.companiesDict[companyId?.toString()]
}

// Selector to get current selected company object
export const selectCurrentCompany = state => {
    const companyId = state.filterData.company
    return companyId ? state.filterData.companiesDict[companyId] : null
}

export default filterDataSlice.reducer
